import React from 'react'
import { Dialog } from 'primereact/dialog';
import { deleteProductDialogFooter } from '../../ComponentsCat/Botones/UnRegistro';

const EliminarUno = ({ deleteProductDialog, hideDeleteProductDialog, product, _deleteProduct }) => {
    //--------------------| Boton de eliminar 1 registro |--------------------
    const unRegistro = deleteProductDialogFooter(hideDeleteProductDialog, _deleteProduct);

    //--------------------| Valor que regresara |--------------------
    return (
        <Dialog
            visible={deleteProductDialog}
            onHide={hideDeleteProductDialog}
            header="Confirmar" style={{ width: '450px' }} modal
            footer={unRegistro}
        >
            <div className="confirmation-content">
                <i className="pi pi-exclamation-triangle mr-3" style={{ fontSize: '2rem' }} />
                {product && <span>¿Estas seguro que deseas desactivar este usuario?</span>}
            </div>
        </Dialog>
    )
}

export default EliminarUno
